import React, { PureComponent } from "react";
import Tag from "./tag";
import "./doctor.css";

export default class Doctor extends PureComponent {
    static get defaultProps() {
        return {
            photoUrl: null,
            name: null,
            tags: null,
            address: null,
        };
    }

    static get propTypes() {
        return {
            photoUrl: React.PropTypes.string,
            name: React.PropTypes.string,
            tags: React.PropTypes.object,
            address: React.PropTypes.string,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    renderSpecializations(specializations) {
        const length = specializations.length;
        return specializations.reduce(function (fullString, value, index) {
            return fullString + value.name + ((index + 1) < length ? ", " : "");
        }, "");
    }

    renderTags() {
        const colors = this.context.muiTheme.palette;
        const elements = [];
        for (const tagType in this.props.tags) {
            if (this.props.tags.hasOwnProperty(tagType) === false) {
                continue;
            }

            const value = this.props.tags[tagType];

            if (tagType === "seesChildren" && value === true) {
                elements.push(<Tag key={tagType} text={"принимает детей"} color={colors.accent1color} />);
                continue;
            }

            if (tagType === "seesAdult" && value === true) {
                elements.push(<Tag key={tagType} text={"принимает взрослых"} color={colors.accent2color} />);
                continue;
            }

            if (tagType === "price") {
                elements.push(<Tag key={tagType} text={`стоимость приема от ${value}р.`} color={colors.accent3color} />);
                continue;
            }

            // Rating is hidden
            if (false && tagType === "rating") { // eslint-disable-line
                elements.push(<Tag key={tagType} text={`рейтинг: ${value}`} color={"rgba(233, 30, 99, 0.3)"} />);
                continue;
            }
        }

        return elements;
    }

    render() {
        return (
            <div className="appointment-doctor">
                {this.props.photoUrl !== null ? <div className="appointment-doctor__photo">
                    <div
                        className="appointment-doctor__photo-image"
                        style={{backgroundImage: `url(${this.props.photoUrl})`}}/>
                </div> : null}

                <div className="appointment-doctor__info">
                    {this.props.name !== null ? <div className="appointment-doctor__name">
                        {this.props.name}
                    </div> : null}

                    {this.props.specializations !== null && !!this.props.specializations ? <div className="appointment-doctor__specializations">
                        {this.renderSpecializations(this.props.specializations)}
                    </div> : null}

                    {this.props.address !== null ? <div className="appointment-doctor__address">
                        {this.props.address}
                    </div> : null}

                    {this.props.tags !== null ? <div className="appointment-doctor__tags">
                        {this.renderTags()}
                    </div> : null}
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/doctor.js
 **/